// extracted by mini-css-extract-plugin
module.exports = {"nav-panel":"lD","navPanel":"lD","nav-panel-bg":"lE","navPanelBg":"lE","nav-panel-content":"lF","navPanelContent":"lF","none":"lG","block":"lH"};